module.exports = __webpack_public_path__ + "img/contact.6e4f3938.jpg";